export const TYPES_TO_EXCLUDE = [
    "68c8df043502301ab90ff513", // Master Analysis
    "6879ebfed2abfc43dcf91615", // AI Analysis
    "681dd41e26456116c7f304ee", // Funder Report
    "689e387f9946bc4b948e7f3a", // Old Report Templates
    "687ea5acaecd239e450bc9f6", // Report Template
    "68663da107d9b2ab202bf1c9", // Landing Page Template
    "66c753543ec7eb95009bf8cc", // Review Guideline
]